module.exports = __webpack_public_path__ + "static/media/IMG_20180319_025912.4487012d.webp";